const tinyMceContentReplace = (arg) => {


  var currentTinymceEditor = null;

  if (jQuery('#wp-content-wrap').hasClass('tmce-active') && window.tinyMCE) {

    currentTinymceEditor = window.tinyMCE.activeEditor;
  } else {
    if (window.tinyMCE && window.tinyMCE.activeEditor) {
      currentTinymceEditor = window.tinyMCE.activeEditor;
    }
  }


  console.info('window.mceeditor_sel - ', window.mceeditor_sel, ' --- ', 'jQuery(\'#wp-content-wrap\').hasClass(\'tmce-active\') -> ', jQuery('#wp-content-wrap').hasClass('tmce-active'));
  if (currentTinymceEditor) {
    if (window.mceeditor_sel != 'notset') {
      if (typeof window.tinyMCE != 'undefined') {
        if (typeof window.tinyMCE.activeEditor != 'undefined') {
          // window.tinyMCE.activeEditor.selection.moveToBookmark(window.tinymce_cursor);
        }

        // console.info("CEVA");
        if (typeof window.tinyMCE.execInstanceCommand != 'undefined') {
          // console.info("CEVA1");
          window.tinyMCE.execInstanceCommand('content', 'mceInsertContent', false, arg);
        } else {

          // console.info("CEVA2", ed, ed.selection, ed.selection.getContent());
          if (currentTinymceEditor && currentTinymceEditor.execCommand) {
            // console.info("CEVA21");
            currentTinymceEditor.execCommand('mceReplaceContent', false, arg);

            if (window.remember_sel) {

              // ed.dom.remove(ed.dom.select('div')[0])
              currentTinymceEditor.dom.remove(window.remember_sel);

              window.remember_sel = null;
            }
            // window.tinyMCE.get('content').execCommand('mceInsertContent', false, arg);
          } else {

            console.info("CEVA22");
            window.tinyMCE.execCommand('mceReplaceContent', false, arg);
          }
        }
      }


    } else {

      window.tinyMCE.execCommand('mceReplaceContent', false, arg);
    }
  } else {
    var currentContent = '';

    if(jQuery("#content").length){
      currentContent = jQuery("#content").val();
    }


    // console.log('here -->' + currentContent + '<-- ', aux);
    var bigaux = currentContent + arg;
    //console.log('here -->'+arg+'<-- ',bigaux,'here -->'+window.htmleditor_sel+'<-- ');
    if (window.htmleditor_sel) {
      bigaux = currentContent.replace(window.htmleditor_sel, arg);
    }
    //console.log('here -->'+arg+'<-- ',bigaux);
    if(jQuery("#content").length) {
      jQuery("#content").val(bigaux);
    }
  }
};

exports.tinyMceContentReplace = tinyMceContentReplace;